import type { ReactNode } from "react";
import { MdClose } from "react-icons/md";
import styles from "./ProfileConfirmPanel.module.scss";

export interface ProfileConfirmPanelProps {
  providerName: string;
  accountEmail: string;
  /** A second line, where the provider needs one. */
  note?: ReactNode;
  /** Renders the grey panel with an × that calls this; omitted keeps it plain. */
  onDismiss?: () => void;
  /** The "Yes, Continue" / copy buttons. */
  children: ReactNode;
}

/** "This will open {provider} as …": names the mailbox about to open before the settings are opened. */
const ProfileConfirmPanel = ({ providerName, accountEmail, note, onDismiss, children }: ProfileConfirmPanelProps): JSX.Element => (
  <div className={`${styles.confirm} ${onDismiss ? styles.confirmPanel : ""}`}>
    {onDismiss ? (
      <button type="button" className={styles.dismiss} aria-label="Dismiss" onClick={onDismiss}>
        <MdClose aria-hidden="true" />
      </button>
    ) : null}
    <p className={styles.confirmText}>
      This will open {providerName} as: <strong>{accountEmail}</strong>
    </p>
    {note ? <p className={styles.confirmNote}>{note}</p> : null}
    <div className={styles.actions}>{children}</div>
  </div>
);

export default ProfileConfirmPanel;
